// extracted by css-extract-rspack-plugin
export default {"BaseCell":"sub-issues-progress-renderer-module__BaseCell__rgUaM","ButtonBase":"sub-issues-progress-renderer-module__ButtonBase__O4DOk"};